var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box container",attrs:{"id":"email-verification"}},[(_vm.success)?_c('p',{staticClass:"has-text-success"},[_vm._v(_vm._s(_vm.$t('account.email_verification_success')))]):_vm._e(),(_vm.errorMessage)?_c('p',{staticClass:"has-text-danger"},[_vm._v(_vm._s(_vm.$t(_vm.errorMessage)))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }